import React from 'react';
import flowbg from '../../assets/images/flow-bg.png';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { StaticQuery, graphql } from "gatsby"

var settings = {
   dots: false,
   infinite: true,
   speed: 500,
   slidesToShow: 3,
   slidesToScroll: 3,
   responsive: [
      {
         breakpoint: 1024,
         settings: {
           slidesToShow: 3,
           slidesToScroll: 3,
           infinite: true,
           dots: false
         }
       },
       {
         breakpoint: 992,
         settings: {
           slidesToShow: 2,
           slidesToScroll: 1,
           infinite: true,
           dots: false
         }
       },
       {
         breakpoint: 767,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 2,
           initialSlide: 2
         }
       },
       {
         breakpoint: 480,
         settings: {
           slidesToShow: 1,
           slidesToScroll: 1
         }
       }
   ]
 };

const WorkflowBox = () => (
   <StaticQuery
         query={graphql`
            query {
                allWpPage(filter: {slug: {eq: "work-flow"}}) {
                    edges {
                      node {
                        slug
                        TeamlanceWorkflow {
                          header {
                            title
                            description
                          }
                          workSteps {
                            steps {
                              description
                              readMoreLink
                              readMoreText
                              title
                              subTitle
                            }
                          }
                          workFeatures {
                            features {
                              title
                              iconSvg
                              description
                            }
                          }
                        }
                      }
                    }
                  }
            }
         `}
         render={data => {
            return(
               data && data.allWpPage &&
              data.allWpPage.edges &&
              data.allWpPage.edges[0] &&
              data.allWpPage.edges[0].node &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workFeatures &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workFeatures.features &&
              data.allWpPage.edges[0].node.TeamlanceWorkflow.workFeatures.features.length>0 &&
              <section className="flow-boxes">
               <div className="boxes-bg">
                   <img alt="flowbg" src={flowbg}/>
                </div>
               <div className="container">
                  <div className="row">
                     <Slider id="myaddCarousel" {...settings} className="services-items">
                        {data.allWpPage.edges[0].node.TeamlanceWorkflow.workFeatures.features.map((features,key)=>{
                             return(
                              <div key={key} className="item">
                                    <div className="flow-inner">
                                       <div className="side-grps">
                                          <svg width="120" height="67" viewBox="0 0 120 67" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M30.813 47.8682L0.75089 -24.7448L156.751 -24.7448L156.751 66.3927L58.5314 66.3927C46.3956 66.3927 35.4551 59.0811 30.813 47.8682Z" fill="white" stroke="#CBE5FF"/>
                                          </svg>
                                       </div>
                                       <div dangerouslySetInnerHTML={{ __html: features.iconSvg }} className="flow-icon  f-1"></div>
                                       <h6>{features.title}</h6>
                                       <p>{features.description}</p>
                                    </div>
                               </div>
                             )
                          })}
                     </Slider>
                  </div>
                  <div className="row mobile-hidden">
                    <Slider id="myaddCarousel" {...settings} className="services-items">
                        {data.allWpPage.edges[0].node.TeamlanceWorkflow.workFeatures.features.map((features,key)=>{
                             return(
                              <div key={key} className="item">
                                    <div className="flow-inner">
                                       <div className="side-grps">
                                          <svg width="120" height="67" viewBox="0 0 120 67" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M30.813 47.8682L0.75089 -24.7448L156.751 -24.7448L156.751 66.3927L58.5314 66.3927C46.3956 66.3927 35.4551 59.0811 30.813 47.8682Z" fill="white" stroke="#CBE5FF"/>
                                          </svg>
                                       </div>
                                       <div dangerouslySetInnerHTML={{ __html: features.iconSvg }} className="flow-icon  f-4"></div>
                                       <h6>{features.title}</h6>
                                       <p>{features.description}</p>
                                    </div>
                               </div>
                             )
                          })}
                     </Slider>
                  </div>
               </div>
               <div className="why-triangle">
                  <svg width="489" height="212" viewBox="0 0 489 212" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M490 67.5004L366.13 17.6306L7.49989 116.5L490 141.5L490 67.5004Z" fill="#F4F8FF"></path>
                  </svg>
               </div>
            </section>
            )
         }}
      />
  
)

export default WorkflowBox;